import type { InvoicesOverviewsAdditionalFilter } from '@weft/api-definition';
import { INVOICES_OVERVIEWS_ADDITIONAL_FILTERS } from '@weft/api-definition';
import { validateEnumArray } from '@weft/utils';
import { useStateParams } from '../../../../hooks/use-state-params';
import { serializeStringArrayParam } from '../../../../utils/params-formatting';

export function useSelectedAdditionalFilters() {
  return useStateParams<InvoicesOverviewsAdditionalFilter[]>([], 'additionalFilters', serializeStringArrayParam, deserializeAdditionalFilters);
}

function deserializeAdditionalFilters(AdditionalFiltersArray: string): InvoicesOverviewsAdditionalFilter[] | null {
  const additionalFilters = AdditionalFiltersArray.split(',');

  validateEnumArray(additionalFilters, INVOICES_OVERVIEWS_ADDITIONAL_FILTERS);

  return additionalFilters;
}